import { graphql, type ResultOf } from '@newfront-insurance/graphql-frontend';

export const SKILL_GROUP_PEOPLE_FIELDS = graphql(`
  fragment SkillGroupPeopleFields on SkillGroup @_unmask {
    uuid
    parentGroupUuid
    admins
    managers
    members
    inheritedRoles
    adminEmployees {
      userUuid
      fullName
      email
      imageUrl
    }
    managerEmployees {
      userUuid
      fullName
      email
      imageUrl
    }
    memberEmployees {
      userUuid
      fullName
      email
      imageUrl
    }
  }
`);

export const GET_SKILL_GROUP_PEOPLE = graphql(
  `
    query GetSkillGroupPeople($groupId: String!) {
      getSkillGroup(groupId: $groupId) {
        ...SkillGroupPeopleFields
      }
    }
  `,
  [SKILL_GROUP_PEOPLE_FIELDS],
);

/** A group's admins and managers with their profiles. Members page through searchSkillGroupPeople instead. */
export const GET_SKILL_GROUP_LEADS = graphql(`
  query GetSkillGroupLeads($groupId: String!) {
    getSkillGroup(groupId: $groupId) {
      uuid
      admins
      managers
      adminEmployees {
        userUuid
        fullName
        email
        imageUrl
      }
      managerEmployees {
        userUuid
        fullName
        email
        imageUrl
      }
    }
  }
`);

export const TRANSITION_SKILL_GROUP_USER_ROLE = graphql(
  `
    mutation TransitionSkillGroupUserRole($groupId: String!, $userUuid: String!, $role: SkillGroupTransitionRole!) {
      transitionSkillGroupUserRole(groupId: $groupId, userUuid: $userUuid, role: $role) {
        ...SkillGroupPeopleFields
      }
    }
  `,
  [SKILL_GROUP_PEOPLE_FIELDS],
);

export type SkillGroupPeople = ResultOf<typeof GET_SKILL_GROUP_PEOPLE>['getSkillGroup'];

/** What a team manager handoff changes. Members' profiles page through searchSkillGroupPeople instead. */
export type SkillGroupTeamManagerTransfer = Pick<
  SkillGroupPeople,
  'uuid' | 'parentGroupUuid' | 'admins' | 'managers' | 'members' | 'managerEmployees'
>;

/** Hands a team to someone in its organization. The team's previous managers stay on it as members. */
export const TRANSFER_SKILL_GROUP_TEAM_MANAGER = graphql(`
  mutation TransferSkillGroupTeamManager($groupId: String!, $userUuid: String!) {
    transferSkillGroupTeamManager(groupId: $groupId, userUuid: $userUuid) {
      __typename
      uuid
      parentGroupUuid
      admins
      managers
      members
      managerEmployees {
        userUuid
        fullName
        email
        imageUrl
      }
    }
  }
`);
